<template>
    <div class="body">
         <header class="header-section">
            <h1 class="main-title">学历提升</h1>
            <h1 class="main-title">🌟拓展未來的边界</h1>
            <div class="subtitle-wrapper">
                <span class="subtitle-badge">提升</span>
                <span class="subtitle-badge">突破 </span>
                <span class="subtitle-badge">进阶</span>
            </div>
        </header>

        <section class="quote-card">
            <p class="p-highlight">看见更广阔的发展空间。</p>
            <div class="p-content">
                <p>让选择，不在受限于当下。</p>
            </div>
            <div class="p-content">
                <p>下一程，由此启航。</p>
            </div>
        </section>

        <div class="wrapper">
            <div class="course-section">
                <div class="course-grid">
                    <div 
                        v-for="(item, index) in courseList" 
                        :key="'course-' + index" 
                        class="course-item"
                        @click="handleCourseClick(item)"
                    >
                        <span class="check-mark"></span>
                        <span class="course-name">{{ item.name }}</span>
                        <span class="arrow-icon">→</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 动态展示统计区域 -->
        <div class="stats-container" v-if="currentStats">
            <div class="stat-item">
                <p>🚀{{ currentStats.progressing }} 名学员正在稳步进阶</p>
                <p>🏅已有 {{ currentStats.graduated }} 人迈向更高学历</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selected: { type: Array, default: () => [] }
    },
    data() {
        return {
            courseList: [], // 存储 { name: string, url: string } 对象
            // 定义统计数据映射规则
            // key: 用于匹配的标识（可以是单个课程名，也可以是组合字符串，这里采用更灵活的匹配逻辑）
            statsConfig: [
                {
                    // 匹配条件：包含 "中专招生"
                    match: (names) => names.includes('中专招生'),
                    data: { progressing: '21', graduated: '1,939' }
                },
                {
                    // 匹配条件：包含 "圆梦计划" 和 "高升专招生" (题目描述：圆梦计划；高升专招生)
                    // 注意：如果顺序不固定，建议检查是否同时包含这两个
                    match: (names) => names.includes('圆梦计划') && names.includes('高升专招生'),
                    data: { progressing: '437', graduated: '13,623' }
                },
                {
                    // 匹配条件：包含 "圆梦计划", "专升本招生", "专升硕招生"
                    match: (names) => 
                        names.includes('圆梦计划') && 
                        names.includes('专升本招生') && 
                        names.includes('专升硕招生'),
                    data: { progressing: '689', graduated: '4,353' }
                },
                {
                    // 匹配条件：包含 "本升硕招生"
                    match: (names) => names.includes('本升硕招生'),
                    data: { progressing: '28', graduated: '1,367' }
                }
            ]
        }
    },
    computed: {
        // 根据当前 courseList 中的名称，匹配对应的统计数据
        currentStats() {
            const names = this.courseList.map(item => item.name);
            
            // 遍历配置，找到第一个匹配项
            const matchedConfig = this.statsConfig.find(config => config.match(names));
            
            return matchedConfig ? matchedConfig.data : null;
        }
    },
    created() {
        if (this.ReportData) {
            this.processEduRecom();
        }
    },
    methods: {
        processEduRecom() {
            const eduRecomStr = this.ReportData.eduRecom;
            if (!eduRecomStr) {
                this.courseList = [];
                return;
            }

            // 1. 分割字符串
            const names = eduRecomStr.split(';').map(n => n.trim()).filter(n => n);
            
            // 2. 定义链接映射规则
            const zhongzhuanUrl = 'https://iedu.foxconn.com/edu/#/zhongzhuan';
            const dreamUrl = 'https://iedu.foxconn.com/edu/#/dream';
            const chengrenUrl = 'https://iedu.foxconn.com/edu/#/chengren';
            const shuoshiUrl = 'https://iedu.foxconn.com/edu/#/shuoshi';

            // 3. 生成课程列表对象
            this.courseList = names.map(name => {
                let url = '';
                if (name === '中专招生') {
                    url = zhongzhuanUrl;
                } else if (name === '圆梦计划') {
                    url = dreamUrl;
                } else if (name === '专升本招生' || name === '高升专招生') {
                    url = chengrenUrl;
                } else if(name === '专升硕招生' || name === '本升硕招生'){
                    url = shuoshiUrl;
                } else {
                    // 默认链接
                    url = chengrenUrl; 
                }
                return {
                    name,
                    url
                };
            });
        },
        handleCourseClick(item) {
            const view= {
                eduUrl: item.name
            };
            this.$emit('handleCourseClick', view);
            if (item.url) {
                window.location.href = item.url;
            }
        }
    }
}
</script>

<style scoped>
/* ... 原有样式保持不变 ... */
:root {
    --primary-green: #2d6a4f;
    --light-green: #d8f3dc;
    --accent-gold: #b78628;
    --text-main: #1b4332;
    --glass-bg: rgba(255, 255, 255, 0.85);
}

.body {
    background: 
        url("../../assets/26May/logo.png") right  top  no-repeat,
        url("../../assets/26May/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden; /* 禁止全局滚动 */
    color: #333;
    box-sizing: border-box;
    padding: 20px 0;
}

/* 2. 头部：精致化 */
.header-section {
  padding-top: 6vh;
  text-align: center;
  margin-bottom: 15px;
}
.main-title {
  font-size: 24px;
  color: #008777;
  margin: 0;
  font-weight: 800;
}
.subtitle-wrapper {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: #42a79d;
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  opacity: 0.8;
}

/* 3. 引用卡片：减少空间占用 */
.quote-card {
  width: 88%;
  background: rgba(255, 255, 255, 0.7);
  border-left: 4px solid #42a79d;
  padding: 12px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}
.p-highlight {
  font-weight: bold;
  color: #42a79d;
  margin: 0 0 5px 0;
}
.p-content {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}
/* 课程列表区域 */
.wrapper {
    width: 90%;
    margin: 0 auto;
}

.course-section {
    background: var(--glass-bg);
    border-radius: 16px;
}

/* 交互式课程项 */
.course-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.course-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: #fff;
    border: 1.5px solid #e0e0e0;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
}

.check-mark {
    display: none; 
}

.arrow-icon {
    color: #ccc;
    font-weight: bold;
    transition: color 0.3s;
}

.course-item:hover {
    border-color: #2d6a4f;
    background: #f9fdfa;
}

.course-item:hover .arrow-icon {
    color: #2d6a4f;
}

.course-item:active {
    transform: scale(0.98);
}

.course-name {
    font-size: 0.95rem;
    font-weight: 500;
    color: #333;
}

/* 新增：统计数据样式 */
.stats-container {
    margin-top: 20px;
    width: 90%;
    max-width: 600px;
    text-align: center;
    animation: fadeIn 0.5s ease-in-out;
}

.stat-item p {
    margin: 5px 0;
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
    .body {
        background: url("../../assets/26May/pcbg.png") no-repeat center;
        background-size: cover;
    }
    .quote-card, .wrapper {
        width: 600px;
    }
    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}

.mt-4 { margin-top: 24px; }
</style>